import { useState } from "react";
import Seo from "../components/generic/Seo";

const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const secondaryColor = "var(--bs-secondary)";

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://formbold.com/s/objw8", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(form),
      });

      if (response.ok) {
        setStatus("Message sent successfully!");

        setForm({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        setStatus("Failed to send message!");
      }
    } catch (err) {
      console.error("FormBold Error:", err);
      setStatus("Failed to send message!");
    }
  };

  const objSeo = {
    title: "Springevening Private Limited - Contact Us",
    keywords:
      "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Brand reflection, Maximizing brand reach, SEO optimization, Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
    pathSlug: "/contactus",
    description:
      "Contact us at Springevening Private Limited for inquiries, support, or collaboration. We are here to assist you with your software needs and provide the best solutions for your business.",
  };

  return (
    <>
      <Seo data={objSeo} />

      <div className="container my-5 col-lg-6">
        <h2 className="mb-4 text-accent">Contact Us</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="text-secondary">Name</label>

            <input
              type="text"
              name="name"
              className="form-control"
              value={form.name}
              onChange={handleChange}
              style={{
                color: secondaryColor,
                caretColor: secondaryColor,
              }}
              required
            />
          </div>

          <div className="mb-3">
            <label className="text-secondary">Email</label>

            <input
              type="email"
              name="email"
              className="form-control"
              value={form.email}
              onChange={handleChange}
              style={{
                color: secondaryColor,
                caretColor: secondaryColor,
              }}
              required
            />
          </div>

          <div className="mb-3">
            <label className="text-secondary">Phone</label>

            <input
              type="text"
              name="phone"
              className="form-control"
              value={form.phone}
              onChange={handleChange}
              style={{
                color: secondaryColor,
                caretColor: secondaryColor,
              }}
            />
          </div>
          <div className="mb-3">
            <label className="text-secondary">Message</label>

            <textarea
              name="message"
              rows={4}
              className="form-control"
              value={form.message}
              onChange={handleChange}
              style={{
                color: secondaryColor,
                caretColor: secondaryColor,
              }}
              required
            />
          </div>

          <button className="btn btn-accent" type="submit">
            Submit
          </button>
          {status && <p className="mt-3 text-secondary">{status}</p>}
        </form>
      </div>
    </>
  );
};

export default ContactPage;
